export const timeline = {
  lineDurationMs: 9600,
  settleDurationMs: 750,
  holdDurationMs: 2100,
  get totalDurationMs() {
    return this.lineDurationMs + this.settleDurationMs + this.holdDurationMs;
  }
};

export const weeklyTimeline = {
  get totalDurationMs() {
    return timeline.totalDurationMs;
  }
};

export function easeInOut(t: number): number {
  return 0.5 - 0.5 * Math.cos(Math.PI * t);
}

export function getTimelineState(elapsedMs: number, pointCount: number) {
  const lineProgress = Math.min(1, elapsedMs / timeline.lineDurationMs);
  const finishProgress = elapsedMs <= timeline.lineDurationMs
    ? 0
    : Math.min(1, (elapsedMs - timeline.lineDurationMs) / timeline.settleDurationMs);
  const holdProgress = elapsedMs <= timeline.lineDurationMs + timeline.settleDurationMs
    ? 0
    : Math.min(1, (elapsedMs - timeline.lineDurationMs - timeline.settleDurationMs) / timeline.holdDurationMs);
  const eased = easeInOut(lineProgress);
  const visibleCount = Math.max(2, Math.floor(2 + eased * (pointCount - 2)));

  return {
    lineProgress,
    finishProgress,
    holdProgress,
    visibleCount,
    timelineProgress: Math.min(1, elapsedMs / timeline.totalDurationMs)
  };
}
